import { clearLibraryDocumentPreview } from '@heidi/evidence';

import { getProjectClientCapabilities } from '../../data/projects/clientCapabilities';
import {
  useCreateAndOpenProject as useCreateAndOpenProjectCore,
  useCreateProjectCore as useCreateProjectCoreImpl,
  useCreateWorkChatProject as useCreateWorkChatProjectImpl,
  type CreateProjectGuard,
  type ProjectCreationPorts,
  type UseCreateAndOpenProject,
  type UseCreateAndOpenProjectOptions,
  type UseCreateWorkChatProject,
} from '../../data/projects/useCreateAndOpenProject';
import { getWorkHostPort } from '../work-home/work-home-ports';
import { useCreateProject } from './hooks';

/**
 * The app half of a Work create: the RPA capability probe, the library preview
 * the composer reset clears, and the create mutation bound to the chat sidebar.
 * Module-level, so the cores see one stable value.
 */
const projectCreationPorts: ProjectCreationPorts = {
  useCreateProject,
  getClientCapabilities: getProjectClientCapabilities,
  clearLibraryDocumentPreview,
};

export const useCreateProjectCore = (
  args: Parameters<typeof useCreateProjectCoreImpl>[0]
): ReturnType<typeof useCreateProjectCoreImpl> =>
  useCreateProjectCoreImpl(args, projectCreationPorts);

export const useCreateWorkChatProject = (options?: {
  guard?: CreateProjectGuard;
}): UseCreateWorkChatProject =>
  useCreateWorkChatProjectImpl(options, projectCreationPorts);

/** The Work-home create, navigating once the project exists. */
export const useCreateAndOpenProject = (
  options?: UseCreateAndOpenProjectOptions
): UseCreateAndOpenProject => {
  const onNavigate = getWorkHostPort('shell').useNavigate();
  return useCreateAndOpenProjectCore({ ...options, onNavigate }, projectCreationPorts);
};
